<template>
  <div>
    <NavBar></NavBar>
    <!-- 《隐私政策》  -->
    <div class="c-w6a5nf">
      <div class="content">
        <!-- <p class="text_head">E家保呗 隐私声明</p> -->
        <h1><center class="c-w6a5nf-title">法律声明及隐私政策</center></h1>
        <p>本版本发布日期：2021年11月1日</p>
        <p>生效日期：2021年11月22日</p>
        <h3>一、法律声明</h3>
        <h4>
          在使用E家保呗的所有产品和服务前，请您务必仔细阅读并理解以下条款。一旦您选择使用E家保呗，即表示您认可并接受本条款内容及可能随时更新的内容。
        </h4>
        <h4>一般原则</h4>
        <section>
          以下规则适用于所有E家保呗用户和浏览者，E家保呗可能随时修改这些条款。因为这些条款与您密切相关，您应经常访问本页面以了解当前的条款。这些条款的内容也可能被E家保呗APP页面上或其他特定服务所发布的法律通告而取代，您应该了解这些内容。一旦您接受本条款，即意味着您已经详细阅读并接受了前述这些被引用或取代的条款。
        </section>
        <h4>权利说明</h4>
        <section>
          上海万利保险经纪有限公司（以下合称“万利保险”）对其所发行的或与合作公司所共同发行的，包括但不限于E家保呗APP及相关产品或服务的全部内容，享有知识产权并受法律保护。如果E家保呗未对前述内容作权利声明，并不代表E家保呗对其不享有权利或不主张权利。您应根据法律、法规及诚实信用原则，尊重权利人的合法权益并合法使用该内容。未经万利保险书面许可，任何单位及个人不得以任何方式或理由对上述软件、产品、服务、信息和文字的任何部分进行使用、复制、修改、抄录、传播或与其他产品捆绑使用、销售或以超级链路连接或传送存储于信息检索系统或其他任何商业目的的使用，但对于非商业目的的、个人使用的下载或打印除外。
        </section>
        <section>
          E家保呗APP中使用和显示的商标和标识（以下简称“商标”）是万利保险及其关联公司或合作公司注册和未注册的有关商标，受法律保护，未经允许，您不得擅自使用。E家保呗APP中所载的任何内容未经万利保险书面许可，任何人不得以任何方式使用。
        </section>
        <h4>用户信息</h4>
        <section>
          您在注册成为E家保呗的用户、使用E家保呗的产品和服务时，代表您在知情和同意的情况下，自愿向E家保呗提供您的个人信息，姓名、证件类型、证件号码、证件有效期限、手机号、邮箱、联系地址（以下简称“个人信息”）。
        </section>
        <section>
          在必要情形下第三方可能接触并使用您的个人信息，包括得到授权的E家保呗员工，以及执行与我们的业务、营销活动和数据整理有关工作的其他公司或人员。所有此类人员及公司均需遵守相关保密协议，同时也需遵守国家关于个人信息保护有关法律法规，以确保您的个人信息随时得到保护。除上述用途外，E家保呗不会将您的个人信息用于任何未经您同意的用途。也不会将所接受的您的任何个人信息泄露、篡改或毁损。
        </section>
        <section>您可阅读下面的E家保呗隐私政策以了解更加详细的内容。</section>
        <h4>责任限制</h4>
        <section>
          不论在何种情况下，E家保呗对由于信息网络维护、信息网络连接故障、智能终端、通讯或其他系统的故障、电力故障、罢工、劳动争议、暴乱、起义、骚乱、火灾、洪水、风暴、战争、政府行为、司法行政机关的命令、其他不可抗力或第三方的不作为而造成的不能服务或延迟服务不承担责任。无论在任何情况下，由于使用E家保呗上的信息或由E家保呗链接的信息，或其他与E家保呗链接的网站信息，对您或他人造成的任何损失或损害（包括直接、间接损失或损害，例如收益或利益之损失，智能终端系统之损坏或数据丢失等后果），均由使用者自行承担责任（包括但不限于疏忽责任）。
        </section>
        <section>
          E家保呗所载的信息包括但不限于文本、图片、数据、观点、网页或链接，虽然力图准确或详尽，但E家保呗并不就其所包含的信息和内容的准确、完整、充分和可靠性做任何承诺。E家保呗表明不对这些信息和内容的错误或遗漏承担责任，也不对这些信息和内容做出任何明示或默示的、包括但不限于没有侵犯第三方权利、质量和没有智能终端病毒的保证。
        </section>
        <h4>第三方链接</h4>
        <section>
          E家保呗可能保留有第三方网站或网址的链接，访问这些链接将由用户自己做出决定，E家保呗并不就这些连接上所提供的任何信息、数据、观点、图片陈述或建议的准确性、完整性、充分性和可靠性提供承诺或保证。E家保呗没有审查过任何第三方网站，对这些网站及其内容不进行控制，也不负任何责任。如果您决定访问任何与本站链接的第三方网站，其可能带来的结果和风险全部由您自己承担。
        </section>
        <h4>适用法律和管辖权</h4>
        <section>
          通过访问E家保呗软件平台或使用E家保呗提供的服务，即表示您同意该访问或服务受中华人民共和国法律的约束，且您同意受中华人民共和国法院的管辖。访问或接受服务过程中，发生的争议应当争取协商解决，协商不成的，各方一致同意至万利保险保险经纪有限公司住所所在地有管辖权的法院诉讼解决。
        </section>
        <h3>二、隐私政策</h3>
        <section>
          1、为了向您提供服务所需，我们会按照合法、正当、必要的原则收集您的信息和获取相关授权。
        </section>
        <section>
          2、如果为了向您提供服务而需要将您的信息共享至第三方，我们将评估该第三方收集信息的合法性、正当性、必要性。我们将要求第三方对您的信息采取保护措施并且严格遵守相关法律法规与监管要求。另外，我们会按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认、弹窗提示等形式征得您的同意或确认第三方已经征得您的同意。
        </section>
        <section>
          3、如果为了向您提供服务而需要从第三方获取您的信息，我们将要求第三方说明信息来源，并要求第三方保障其提供信息的合法性；如果我们开展业务需进行的个人信息处理活动超出您原本向第三方提供个人信息时的授权范围，我们将征得您的明确同意。
        </section>
        <section>
          <strong>
            万利保险保险经纪有限公司（办公地址：中国(上海)自由贸易试验区崂山路526号18层B5、C5室；联系方式：021-68391209；以下合称“我们”）尊重并保护您的隐私。您使用我们的服务时，我们将按照本隐私政策（以下简称“本政策”）收集、存储、使用及对外提供您的信息。同时，我们会通过本政策向您说明，我们如何为您提供访问、更新、管理和保护您的信息的服务。本政策与您使用我们的服务关系紧密，我们建议您仔细阅读并理解本政策全部内容，做出您认为适当的选择。我们努力用通俗易懂、简明扼要的文字表达，并对本政策中与您的权益存在重大关系的条款和个人敏感信息，采用粗体字进行标注以提示您注意。
          </strong>
        </section>
        <section>
          为了遵守国家法律法规及监管规定（例如：进行实名制管理、履行反洗钱职责、安全管理），也为了向您提供服务及提升服务质量，我们需要收集、存储、使用及对外提供您的信息。您同意我们按照本政策约定处理您的信息，以便您享受优质、便捷、个性化的服务，同时更好地保护您的账户及资金安全。
        </section>
        <h4>我们收集以下信息</h4>
        <section>
          在您使用E家保呗各项业务功能（以下简称“服务”）的过程中，我们需要收集您的一些信息，用以向您提供服务、提升我们的服务质量、保障您的账户和资金安全以及符合国家法律法规及监管规定:
        </section>
        <h4>（一）您在使用我们服务时主动提供的信息</h4>
        <h4>1、账户注册</h4>
        <section>
          在您注册E家保呗账户或使用E家保呗服务时，您需提供昵称、头像、手机号码作为账户登录名。如您不提供前述信息，可能无法注册E家保呗账户或无法使用E家保呗服务。
        </section>
        <h4>2、实名认证</h4>
        <section>
          我们需根据相关法律法规及监管要求，您需要提供
          <strong>
            姓名、证件类型、证件号码、证件有效期限。提示您适时提供有效身份证件的提示您适时提供彩色影印件或照片
          </strong>
          以供我们核对并留存；如您不提供前述彩色影印件、照片或不同意我们留存，可能无法使用与监管要求相关的部分服务，但不影响您使用我们提供的其他服务。
        </section>
        <h4>3、快捷支付</h4>
        <section>
          为了您能使用快捷支付服务，购买产品，您需提供您的
          <strong>
            开户行名称、银行卡卡号、银行卡有效期、姓名、身份证号码、银行预留手机号
          </strong>
          。我们会将前述信息与通过第三方支付公司进行验证。如您不提供前述信息，可能无法使用快捷支付服务，但不影响您使用我们提供的其他服务。
        </section>
        <h4>4、重要操作行为验证</h4>
        <section>
          为了保障您的账户和资金安全，在您进行一些重要的账户操作时（找回密码、挂失账户、冻结交易资金），我们需要验证您的身份，为此您可能需向我们提供
          <strong>身份证件影印件、手持身份证照片、交易凭证</strong>
          及其他在具体业务开展过程中基于您的同意而收集的可识别您身份的证明资料；如您不同意提供前述信息，您将无法完成特定操作，但不影响您使用我们提供的其他服务。
        </section>
        <h4>（二）我们在您使用服务时获取的信息</h4>
        <h4>1、账户安全管理</h4>
        <section>
          为了保障向您提供的服务的安全稳定运行，预防交易和资金风险，预防病毒、木马程序或其他恶意程序、网站，我们可能需要记录您使用的E家保呗服务类别、方式及设备品牌、设备型号、设备名称、IMEI、IMSI、硬件序列号、Android
          ID、MAC地址、应用安装列表、运行列表信息、IP地址、设备软件版本信息、设备标识符、所在地区、网络状态、设备相关应用信息以及其他与E家保呗服务相关的日志信息。前述信息当中包含您的个人敏感信息，如您不同意我们记录前述信息，可能无法完成风控验证。
        </section>
        <h4>2、权限获取说明</h4>
        <section>
          读取及写入存储器权限：当您安装E家保呗APP时，E家保呗APP会向您申请获取此权限，目的是为了保障E家保呗APP的稳定运行。E家保呗APP承诺仅读取或缓存必要的信息。如您选择不开启此权限，您将无法使用与此权限相关的特定功能，但不影响您使用E家保呗APP提供的其他服务。
        </section>
        <section>
          位置信息权限：当您在线录单时后，您可以选择开启此权限，以便满足部分保险产品对销售区域的限制；如您选择不开启此权限，您将无法下单需要定位的产品，但不影响您使用E家保呗其他功能
        </section>
        <section>
          摄像头、相册及麦克风权限：当您使用录单、投保、头像图片设置功能时，您需要开启摄像头权限和/或相册权限和/或麦克风权限(以您使用的具体功能为准)，以便您进行实时拍摄或图片/视频上传。如您选择不开启相应权限，您将无法使用与实时拍摄或图片/视频上传相关的特定功能，但不影响您使用E家保呗APP提供的其他服务
        </section>
        <section>
          请您理解，我们向您提供的服务是不断更新和发展的，基于该服务我们需要收集您的信息或申请您的授权的，我们会通过页面提示、交互流程、协议约定的方式另行向您说明信息收集或申请授权的范围与目的，并征得您的同意。我们会按照本政策以及相应的用户协议约定使用、存储、对外提供及保护您的信息；如您选择不提供前述信息或不同意授权，您可能无法使用某项或某部分服务，但不影响您使用我们提供的其他服务。此外，第三方主体可能会通过E家保呗APP向您提供服务。当您进入第三方主体运营的服务页面时，请注意相关服务由第三方主体向您提供。涉及到第三方主体向您收集个人信息的，建议您仔细查看第三方主体的隐私政策或协议约定。
        </section>
        <h4>我们如何使用信息</h4>
        <h4>我们在提供如下业务功能或服务的过程中使用您的个人信息：</h4>
        <table class="firstTable" border="1" bordercolor="#000000">
          <tbody>
            <tr>
              <td>使用目的</td>
              <td>个人信息范围</td>
              <td>收集方式</td>
            </tr>
            <tr style="height: 20px">
              <td>标记设备和用户的唯一性</td>
              <td>设备号</td>
              <td>根据用户授权后，主动获取</td>
            </tr>
            <tr style="height: 21px">
              <td>对身份核验、个税申报、地区识别</td>
              <td>姓名+身份证号</td>
              <td>用户主动上传、通过第三方接口识别</td>
            </tr>
            <tr style="height: 21px">
              <td>投保保险产品</td>
              <td>
                投保人的姓名、证件类型、证件号码、证件有效期、电话号码、电子邮箱、职业类别、地址、收入信息、被保险人与投保人关系、受益人信息
              </td>
              <td>用户主动上传</td>
            </tr>
            <tr style="height: 21px">
              <td>用于支付保费、提现、接受理赔款</td>
              <td>银行卡号、开户名、开户手机号</td>
              <td>用户主动上传、通过第三方接口识别</td>
            </tr>
            <tr style="height: 21px">
              <td>用于核验用户身份</td>
              <td>人脸录像+身份证</td>
              <td>用户主动上传、通过第三方接口识别</td>
            </tr>
            <tr style="height: 21px">
              <td>辅助营销方案、识别保险销售地区、风控</td>
              <td>定位信息，包括经纬度、省市县区街道</td>
              <td>根据用户授权后，主动获取</td>
            </tr>
            <tr style="height: 30px">
              <td>理赔审核的必要材料</td>
              <td>病历信息、治疗信息及相关发票</td>
              <td>用户主动上传、传给保险公司审核</td>
            </tr>
            <tr style="height: 21px">
              <td>用于登录、绑定银行卡进行验证</td>
              <td>手机号及验证码</td>
              <td>用户填写上传</td>
            </tr>
            <tr style="height: 21px">
              <td>用于确认保单接收、商品接收、投保地区的确认</td>
              <td>用户所在省市区街道详细地址</td>
              <td>用户主动上传</td>
            </tr>
            <tr style="height: 21px">
              <td>
                辅助保障测算、保单整理 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp;
              </td>
              <td>
                通讯录，包括姓名、手机号 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp;
              </td>
              <td>
                用户填写上传或开启权限上传 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp;
              </td>
            </tr>
            <tr style="height: 21px">
              <td>
                理赔、凭证、头像、识别内容 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp;
              </td>
              <td>
                图片、视频 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp;
              </td>
              <td>
                用户主动上传 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp;
              </td>
            </tr>
            <tr style="height: 21px">
              <td>
                确认用户签约意愿 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp;
              </td>
              <td>
                电子签名信息 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp;
              </td>
              <td>
                用户上传后，传给第三方存证机构 &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp;
              </td>
            </tr>
            <tr style="height: 21px">
              <td>
                添加保单，保单年检，为代理人维护客户的保单服务 &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              </td>
              <td>
                投被保人姓名、性别、年龄、身份证、生日、受益人姓名、投保人开户行、开户名、账号
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              </td>
              <td>
                用户填写上传 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp;
              </td>
            </tr>
          </tbody>
        </table>

        <section>
          我们要将信息用于本政策未载明的其他用途时，会按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认动作等形式再次征得您的同意。
        </section>
        <section>
          我们会采取脱敏、去标识化等方式对您的信息进行综合统计、分析加工，以便为您提供更加准确、个性、流畅及便捷的服务，或帮助我们评估、改善或设计服务及运营活动。
        </section>
        <section>
          原则上我们不会将您的信息进行公开披露。如确需公开披露时，我们会向您告知公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明确同意。但是根据相关法律法规及国家标准，在以下情形中，我们可能会依法共享、披露您的个人信息无需征得您的同意：
          <br />
          （1）与国家安全、国防安全直接相关的；
          <br />
          （2）与公共安全、公共卫生、重大公共利益直接相关的；
          <br />
          （3）与犯罪侦查、起诉、审判和判决执行等直接相关的；
          <br />
          （4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
          <br />
          （5）根据法律法规或监管要求向相关部门进行报告；
          <br />
          （6）法律法规规定或其他有权机关强制性要求的其他情形。
        </section>
        <h4>我们如何使用</h4>
        <section>
          为使您获得更轻松的访问体验，您访问E家保呗网站或使用E家保呗APP提供的服务时，我们可能会通过小型数据文件识别您的身份，这么做可帮您省去重复输入注册信息的步骤，或者帮助判断您的账户安全状态。这些数据文件可能是Cookie，Flash
          Cookie，您的浏览器或关联应用程序提供的其他本地存储（以下简称“Cookie”）。请您理解，我们的某些服务只能通过使用Cookie才可得到实现。如您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝E家保呗的Cookie。多数浏览器工具条中的“帮助”部分会告诉您怎样防止您的浏览器接受新的Cookie，怎样让您的浏览器在您收到一条新Cookie时通知您或者怎样彻底关闭Cookie。此外，您可以通过改变浏览器附加程序的设置，或通过访问提供商的网页，来关闭或删除浏览器附加程序使用的Flash
          Cookie及类似数据。但这一举动在某些情况下可能会影响您安全访问E家保呗网站和使用E家保呗提供的服务。
        </section>
        <h4>信息存储地点及期限</h4>
        <section>
          我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。如部分服务涉及跨境业务，我们需要向境外机构传输境内收集的相关个人信息的，我们会按照法律法规和相关监管部门的规定执行，并单独征得您的授权同意并要求接收方按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理这些个人信息。
        </section>
        <section>
          一般而言，我们仅为实现目的所必需的最短时间保留您的个人信息。但在下列情况下，我们有可能因需符合法律要求，更改个人信息的存储时间：
          <br />
          为遵守适用的法律法规等有关规定；
          <br />
          为遵守法院判决、裁定或其他法律程序的规定；
          <br />
          为遵守相关政府机关或法定授权组织的要求；
          <br />
          我们有理由确信需要遵守法律法规等有关规定；
          <br />
          为执行相关服务协议或本政策、维护社会公共利益，为保护们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。
          <br />
          当我们的产品或服务发生停止运营的情形时，我们将采取包括但不限于推送通知、公告等形式通知您，并在合理的期限内删除或匿名化处理您的个人信息。
          <br />
        </section>
        <section>合作第三方软件开发包（以下简称SDK）如何收集、使用信息</section>
        <section>
          为保障E家保呗APP的稳定运行或实现相关功能，我们可能会接入由第三方提供的SDK来实现前述目的。我们接入的第三方SDK主要服务于您及其他用户的需求，因此在满足新的服务需求及业务功能变更时，我们可能会调整们接入的第三方SDK。我们会及时在本说明中向您公开明示接入的第三方SDK情况。目前E家保呗APP接入的第三方SDK列明如下：
        </section>
        <table class="secondTable" border="1" bordercolor="#000000">
          <tbody>
            <tr>
              <td>SDK名称</td>
              <td>收集信息</td>
              <td>实现的功能目的 </td>
              <td>厂商信息</td>
            </tr>
            <tr>
              <td>
                极光推送SDK &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp;
              </td>
              <td>
                <p>BSSID，Android ID，设备型号，网络信息，WLAN MAC，硬件序列号、运行列表</p>
                <p>
                  参考极光推送隐私协议：
                  
                </p>
                <p>
                  <a href="https://www.jiguang.cn/license/privacy">
                    <span>https://www.jiguang.cn/license/privacy</span>
                  </a>
                  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                </p>
              </td>
              <td>
                用于E家保呗APP向手机用户推送消息 &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp;
              </td>
              <td>
                深圳市和讯华谷信息技术有限公司 &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp;
              </td>
            </tr>
            <tr>
              <td>
                小米推送SDK (com.xiaomi.push)&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp;
              </td>
              <td>
                <p>设备标识OAID，加密的Android ID，以及使用推送服务的应用信息如应用包名、版本号和运行状态</p>
                <p>
                  参考小米推送隐私协议：
                  
                </p>
                <p>
                  <a href="https://dev.mi.com/distribute/doc/details?pId=1534">
                    <span>https://dev.mi.com/distribute/doc/details?pId=1534</span>
                  </a>
                  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                </p>
              </td>
              <td>
                用于E家保呗APP向小米手机用户推送消息 &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp;
              </td>
              <td>
                北京小米移动软件有限公司 &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp;
              </td>
            </tr>
            <tr>
              <td>
                支付宝SDK &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp;
              </td>
              <td>
                <span>
                  设备信息，IP地址，MAC地址，设备标识符，设备识别码，位置信息，网络信息，Android_id，运行列表
                </span>
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                <p>
                  参考支付宝官网隐私权政策： &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                  &nbsp; &nbsp; &nbsp;
                </p>
                <p>
                  <a href="https://render.alipay.com/p/c/k2cx0tg8">
                    https://render.alipay.com/p/c/k2cx0tg8
                  </a>
                  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                </p>
                <p>
                  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                </p>
              </td>
              <td>
                可帮助用户完成付款、提供安全认证服务 &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp;
              </td>
              <td>
                支付宝(中国)网络技术有限公司
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </td>
            </tr>
            <tr>
              <td>
                微信OpenSDK &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp;
              </td>
              <td>
                设备型号，设备识别码，IP地址，MAC地址，IMEI，网络信息，运营商信息，IMSI、Android_id
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                <p>
                  参考微信开放平台开发者服务协议： &nbsp; &nbsp; &nbsp; &nbsp;
                  &nbsp; &nbsp; &nbsp; &nbsp;
                </p>
                <p>
                  <a
                    href="https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl"
                  >
                    https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl
                  </a>
                  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                </p>
              </td>
              <td>
                可帮助用户完成付款、分享到微信 &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp;
              </td>
              <td>
                深圳市腾讯计算机系统有限公司 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp;
              </td>
            </tr>
          </tbody>
        </table>
        <h4>我们如何进行个人信息保护</h4>
        <section>
          我们建立了相关内控制度，对可能接触到您的信息的工作人员采取最小够用授权原则；另外，我们的相应网络/系统通过了国家网络安全等级保护的测评。我们每年还会聘请外部独立第三方对我们的信息安全管理体系进行评估。
        </section>
        <section>
          为保障您的信息安全，我们致力于使用行业通行的各种安全技术及配套的管理体系来尽量降低您的信息被泄露、毁损、误用、非授权访问、非授权披露和更改的风险。
        </section>
        <section>
          我们承诺对您的信息进行严格保密。除法律法规及监管部门另有规定外，我们仅在以下情形中与第三方共享您的信息，第三方包括我们的关联公司以及其他合作伙伴。如果为了向您提供服务而需要将您的信息共享至第三方，我们将要求第三方对您的信息采取保护措施，并且严格遵守相关法律法规与监管要求。另外，我们会按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认、弹窗提示等形式征得您的同意，或确认第三方已经征得您的同意。
        </section>
        <section>
          （1）某些产品或服务可能由第三方提供或由我们与第三方共同提供，因此，只有共享您的信息，才能提供您需要的产品或服务；
        </section>
        <section>
          （2）如您选择参与我们和第三方联合开展的活动，我们可能与其共享活动过程中产生的、为完成活动所必要的信息，以便第三方能及时向您发放奖品或为您提供服务，我们会依据法律法规的要求，在活动规则页面或通过其他途径向您明确告知需要向第三方提供何种信息；
        </section>
        <section>
          （3）事先获得您明确同意的情况下，我们会在法律法规允许的范围内，依据您的授权范围与第三方共享您的信息。
        </section>
        <section>
          <strong>
            请您务必妥善保管好您的E家保呗登录名及其他身份要素。您在使用E家保呗服务时，我们会通过您的登录名及其他身份要素来识别您的身份。一旦您泄漏了前述信息，您可能会蒙受损失，并可能对您产生不利。如您发现E家保呗登录名或其他身份要素可能或已经泄露时，请您立即和我们取得联系，以便我们及时采取相应措施以避免或降低相关损失。
          </strong>
        </section>
        <h4>我们如何处理儿童的个人信息</h4>
        <section>
          1、我们的产品、网站和服务主要面向成人。若您是14周岁以下的儿童，在使用我们的产品或服务或向我们提供14周岁以下的儿童的个人信息前，应事先取得该儿童父母或法定监护人的同意。
        </section>
        <section>
          2、对于经父母或其他监护人同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或其他监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。
        </section>
        <section>
          3、如果我们发现在未事先获得可证实的父母或其他监护人同意的情况下收集了儿童的个人信息，或儿童的父母或其他监护人撤回其同意的，则会设法尽快删除相关数据。
        </section>
        <h4>如何管理您的个人信息</h4>
        <section>
          您可通过登录E家保呗账户的方式，查阅您的身份信息、账单信息、账户信息以及绑定的银行卡等个人信息。
        </section>
        <section>
          如发现您的信息有误，您可以根据页面提示自助修改您的信息，您也可以联系我们的客服电话或通过在线客服要求更正。
        </section>
        <section>
          如您希望停止对您位置、信息存储、获取设备信息等个人信息获取的授权，停止授权的操作路径为：手机设置打开对应的应用管理关闭对应权限。（注：不同操作系统的手机操作路径略有差异）
        </section>
        <section>
          您可以联系我们的客服电话或通过在线客服要求注销账户，当您符合账户注销条件并注销账户后，您该账户内的所有信息将被清空，我们将不会再收集、使用或对外提供与该账户相关的个人信息，但您在使用E家保呗服务期间提供或产生的信息我们仍需按照监管要求的时间进行保存，且在该保存的时间内依法配合有权机关的查询。
        </section>
        <section>
          如您发现我们收集、使用您个人信息的行为，违反了法律法规规定或违反了与您的约定，您可联系我们的客服热线或通过在线客服，要求删除相应的信息。
        </section>
        <section>
          为了保障安全，我们可能需要您提供书面请求，或以其他方式证明您的身份，我们将在收到您反馈并验证您的身份后的15天内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。
        </section>
        <h4>个人信息主体获取个人信息副本</h4>
        <section>
          您有权获取您的个人信息副本，您可以通过我们的客服热线021-68391209联系我们，我们将在15个工作日内回复您的请求。在技术可行的前提下，如数据接口已匹配，我们还可按您的要求，直接将您的个人信息副本传输给您指定的第三方。
        </section>
        <h4>约束信息系统自动决策</h4>
        <section>
          在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制作出决定。如果这些决定显著影响您的合法权益，您有权要求我们作出解释，我们也将提供适当的救济方式。
        </section>
        <h4>本政策的修订及更新</h4>
        <section>
          发生下列重大变化情形时，我们会适时对本政策进行更新：
          <br />
          (1)我们的基本情况发生变化，例如：兼并、收购、重组引起的所有者变更；
          <br />
          (2)收集、存储、使用个人信息的范围、目的、规则发生变化；
          <br />
          (3)对外提供个人信息的对象、范围、目的发生变化；
          <br />
          (4)您访问和管理个人信息的方式发生变化；
          <br />
          (5)数据安全能力、信息安全风险发生变化；
          <br />
          (6)用户询问、投诉的渠道和机制，以及外部纠纷解决机构及联络方式发生变化；
          <br />
          (7)其他可能对您的个人信息权益产生重大影响的变化。如本政策发生更新，我们将以推送通知、弹窗提示、发送邮件、短消息或者在E家保呗官方网站发布公告的方式来通知您。如您在本政策更新生效后继续使用E家保呗提供的服务，即表示您已充分阅读、理解并接受更新后的政策并愿意受更新后的政策约束。
          <br />
        </section>
        <h4>如何联系我们</h4>
        <section>
          我们设立了个人信息保护专职部门和个人信息保护专员，如您对本政策或您个人信息的相关事宜有任何疑问、意见或建议，请通过我们的客服热线或者在线客服联系我们。客服部门将会同个人信息保护专职部门及时答复您。
          一般情况下，我们将在十五个工作日内回复并完成核查与处理。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求解决方案：向有管辖权的法院提起诉讼，或向网信、电信、公安及工商等监管部门进行投诉或举报。
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from '@/components/h5header'
export default {
  components: { NavBar },
  data() {
    return {}
  }
}
</script>
<style scoped lang="less">
.c-w6a5nf {
  padding: 15px;
  font-size: 14px;
  &-title {
    color: @c-color-primary;
  }
}
table {
  border-collapse: collapse;
}
.secondTable > tbody > tr > td:nth-child(2) {
  display: inline-block;
  width: 125px;
}
.secondTable > tbody > tr > td > p {
  font-size: 14px;
  text-align: center;
  line-height: 29px;
  word-wrap: break-word;
}
</style>
